import { fetchJsonWithTimeout } from "./fetch-json-timeout.js";

export const STATUS_TIMEOUT_MS = 10_000;

/**
 * @param {typeof fetch} fetchFn
 * @param {{ timeoutMs?: number }} options
 */
export async function loadWaitlistStatus(fetchFn = fetch, options = {}) {
  const timeoutMs = options.timeoutMs ?? STATUS_TIMEOUT_MS;
  try {
    const { res, data } = await fetchJsonWithTimeout(
      fetchFn,
      "/api/status",
      { headers: { Accept: "application/json" } },
      timeoutMs,
    );
    if (!res.ok) {
      return {
        ok: false,
        message: "Não foi possível carregar o formulário. Verifique a conexão e tente novamente.",
      };
    }
    if (data === null || typeof data !== "object" || Array.isArray(data)) {
      return {
        ok: false,
        message: "Resposta inválida do servidor. Tente novamente.",
      };
    }
    if (typeof data.consent_version !== "string" || !data.consent_version.trim()) {
      return {
        ok: false,
        message: "Resposta inválida do servidor. Tente novamente.",
      };
    }
    return {
      ok: true,
      preview: Boolean(data.preview),
      consentVersion: data.consent_version.trim(),
      mode: typeof data.mode === "string" ? data.mode : undefined,
    };
  } catch (err) {
    if (err?.name === "AbortError") {
      return {
        ok: false,
        message: "O carregamento demorou demais. Tente novamente.",
      };
    }
    return {
      ok: false,
      message: "Falha de conexão. Verifique a rede e tente novamente.",
    };
  }
}
